// hooks/useGroups.js
import { useState, useEffect } from 'react';
import axios from 'axios';

export const useGroups = () => {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchGroups = async () => {
            try {
                setLoading(true);
                setError(null);
                
                // ✅ Aggiunto /api/
                const response = await axios.get('/api/gruppi-prodotti');
                
                // ✅ Corretto: response.status invece di response.ok
                if (response.status !== 200) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                // ✅ Corretto: response.data invece di response.json()
                const result = response.data;
                
                if (result.success && Array.isArray(result.data)) {
                    const activeGroups = result.data.filter(cat => cat.attiva !== false);
                    const sortedGroups = activeGroups.sort((a, b) => a.id - b.id);
                    setGroups(sortedGroups);
                } else {
                    setGroups([]);
                }
                
            } catch (err) {
                setError(err.message);
                setGroups([]);
            } finally {
                setLoading(false);
            }
        };
        
        fetchGroups();
    }, []);
    
    return { 
        groups, 
        loading, 
        error 
    };
};

export const useGroupsByCategory = (categoriaId) => {
    const [groupsByCategory, setGroupsByCategory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchGroupsByCategories = async () => {
            if (!categoriaId || isNaN(categoriaId)) {
                setGroupsByCategory(null);
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                setError(null);

                // ✅ Aggiunto /api/
                const response = await axios.get(`/api/gruppi-prodotti/categoria/${categoriaId}`);

                // ✅ Corretto: response.status invece di response.ok
                if (response.status !== 200) {
                    throw new Error(`Errore HTTP: ${response.status}`);
                }

                // ✅ Corretto: response.data invece di response.json()
                const result = response.data;

                if (result.success) {
                    const groupsWanted = result.data.sort((a, b) => a.id - b.id);
                    setGroupsByCategory(groupsWanted);
                    setLoading(false);
                } else {
                    setGroupsByCategory([]);
                    setError(result.message || `Gruppi della categoria ${categoriaId} non trovato`);
                } 
                
            } catch (error) {
                setError(error.message);
                setGroupsByCategory(null);
            }
        };

        fetchGroupsByCategories();
    }, [categoriaId]);

    return { 
        groupsByCategory, 
        loading, 
        error
    };
};